/* global G */
const fn = obj => async (uiState, key) => {
  const re = /^[1-9]+$/
  const { options } = obj[G.CONFIGURATION].validator[key]
  const { error } = options

  if (!re.test(uiState.value)) {
    throw TypeError(error)
  }

  // otherwise, field is valid
  return [uiState, key]
}

export default fn
